



















































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  BFormFile,
  BProgress,
  BFormInput,
  BFormDatepicker,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BSpinner
} from "bootstrap-vue";
import { successAlert, errorAlert } from "@/libs/sweetAlerts/alerts";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import RessifnetDateInput from "@/components/inputs/RessifnetDateInput.vue";
import { required } from "@validations";
import RessifnetQuillEditor from "@/components/inputs/RessifnetQuillEditor.vue";
import { CreateActionPreventionSanteTravailModel, UpdateActionPreventionSanteTravailModel } from "@/api/models/preventionSanteTravail/actionPreventionSanteTravail";
import { TypeActionPreventionSanteTravail } from "@/api/models/preventionSanteTravail/typeActionPreventionSanteTravail";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { DroitsEnum } from "@/api/models/enums/droitsEnum";
import MultipleFileInput from "@/components/inputs/MultipleFileInput.vue";

@Component({
  name: "create-action-prevention-sante-travail",
  components: {
    BFormFile,
    BProgress,
    BFormDatepicker,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    RessifnetDateInput,
    RessifnetQuillEditor,
    MultipleFileInput
  },
})
export default class CreateActionPreventionSanteTravail extends Vue {
  @Prop ({ required: true }) projetId! : string
  required = required;
  dateToday = (new Date().toLocaleString('fr-FR', { month: 'numeric', day: 'numeric', year: 'numeric' }));
  loading = false;

  formTitle: string = "Créer une nouvelle action";
  formIcon: string = "Plus";
  viewMode: boolean = false;
  editMode: boolean = false;
  createMode: boolean = false;

  initialModel: any
  
  listTypes: PaginatedList<TypeActionPreventionSanteTravail> =
    new PaginatedList<TypeActionPreventionSanteTravail>();

  model: UpdateActionPreventionSanteTravailModel | CreateActionPreventionSanteTravailModel = {
    id: undefined,
    typeId: undefined,
    libelle: "",
    duree: undefined,
    dureeHorsVacation: undefined,
    fichiers: [],
    dateAction: this.dateToday
  };

  clearModel = {...this.model};

  fichiersUploaded = [];
  percentUpload: number = 0;

  droitsEnum = DroitsEnum;

  get canEdit() {
    return !this.model.id || this.model.createdBy === this.$store.state.user.user.uid || this.$can(this.droitsEnum.ENTREPRISE_MANAG_TOTAL);
  }

  async created() {
    this.initialModel = JSON.parse(JSON.stringify(this.clearModel));
    await this.loadTypesActions();
  }

  onUploadProgress(percent: any) {
    this.percentUpload = percent;
  }

  askResetModel() {
    this.$bvModal
      .msgBoxConfirm(
        "Etes-vous sûr de vouloir annuler la création de cette action ?",
        {
          title: "Confirmation d'annulation",
          size: "sm",
          okVariant: "primary",
          okTitle: "Oui",
          cancelTitle: "Non",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        }
      )
      .then(async (value) => {
        if (value === true) {
          await this.resetModel();
        } else {
          return;
        }
      });
  }

  resetModel() {
    this.model = {
      id: undefined,
      typeId: undefined,
      libelle: "",
      duree: undefined,
      dureeHorsVacation: undefined,
      fichiers: [],
      dateAction: this.dateToday
    };
    this.fichiersUploaded = [];

    (this.$refs["formValidation"] as any).reset();

  }

  async getAction(id:string, mode?:any){
    this.loading = true;
          await this.$http.ressifnet.actionsPreventionSanteTravail
            .getById(this.$route.params.idEntreprise, this.projetId, id)
            .then((action: any) => {
              if (mode == "edit") {
                this.formTitle = "Editer une action";
                this.formIcon = "Edit2";
                this.viewMode = false;
                this.editMode = true;
              } else if (mode == "view") {
                this.formTitle = "Consulter une action";
                this.formIcon = "Eye";
                this.viewMode = true;
              }

              this.model = {
                id: action.id,
                commentaire: action.commentaire,
                createdBy: action.createdBy,

                libelle: action.libelle,
                duree: action.duree,
                dureeHorsVacation: action.dureeHorsVacation,
                typeId: action.typeId.toString(),
                dateAction: action.dateAction,
                dateSaisie: action.dateSaisie,
                dateModification: action.dateModification,
                fichiers: [],
              };
              this.fichiersUploaded = action.fichiers;
              this.loading = false;

              let formCard = (this.$refs['formCardProjet'] as any);
              if (formCard)
                formCard.scrollIntoView({ behavior: 'smooth' })
            });
  }

  async selectAction(id: string, mode?:any) {
    if (mode == "create") {
      this.formTitle = "Créer une nouvelle action";
      this.formIcon = "Plus";
      this.viewMode = false;
      this.editMode = false;
      this.createMode = true;
      this.clearModel = JSON.parse(JSON.stringify(this.initialModel));
    }else if (mode == "edit"){
      this.viewMode = false;
      this.editMode = true;
      this.createMode = false;
    }else if( mode == "view"){
      this.viewMode = true;
      this.editMode = false;
      this.createMode = false;
    }

    if (id == null || id == '0') {

      if( JSON.stringify(this.clearModel) != JSON.stringify(this.model)){
        console.log(this.model);
        let answer = window.confirm('Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir quitter la page ?');
        if(answer){         
          this.resetModel()
        }
      }   

      setTimeout(() => {
        let formCard = (this.$refs['formCardProjet'] as any);
        if (formCard)
          formCard.scrollIntoView({ behavior: 'smooth' })
      }, 350)
    }
    else {
       if( JSON.stringify(this.clearModel) != JSON.stringify(this.model)){
        let answer = window.confirm('Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir quitter la page ?');
        if(answer){         
          await this.getAction(id, mode);         
        }
      }else {
        await this.getAction(id, mode);         
      }
    }
  }

  async saveAction(callback: any) {
    (this.$refs["formValidation"] as any)
      .validate()
      .then(async (result: boolean) => {
        if (!result) return;
        else {
          // this.model.interventions = this.getFormatedInterventionModel();

          let config = {
            onUploadProgress(progressEvent: any) {
              var percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );

              callback(percentCompleted);
              return percentCompleted;
            },
          };

          if ((this.model as any).id && (this.model as any).id != undefined) {
            this.updateAction(config, this.model);
          } else {
            this.createAction(config, this.model);
          }
        }
      });
  }

  async createAction(config: any, action: any) {    

    this.model = {
      typeId: action.typeId,
      libelle: action.libelle,
      duree: action.duree ?? 0,
      dureeHorsVacation: action.dureeHorsVacation ?? 0,
      fichiers: action.fichiers,
      commentaire: action.commentaire,
      dateAction: action.dateAction,
    };

    await this.$http.ressifnet.actionsPreventionSanteTravail
      .create(this.$route.params.idEntreprise, this.projetId, this.model, config)
      .then(
        (response: string) => {
          successAlert.fire({
            title: "Création d'une action",
            text: "Ajout effectué avec succès",
          });

          this.$emit("element-added");
          this.resetModel();
          this.percentUpload = 0;
          
          (this.$refs.formValidation as InstanceType<typeof ValidationObserver>).reset();
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
          this.percentUpload = 0;
        }
      );
  }


  async downloadFile(fichier:any) {
    if (!fichier.id)
      return;
    else {
      await this.$http.ressifnet.fichiersDossiers
        .downloadFile(fichier.id)
        .then(
          async (response: any) => {
            window.open(response);
          },
          (error: any) => {
            if (error?.response?.data?.errors) {
              errorAlert.fire({
                text: error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
              });
            } else {
              errorAlert.fire({
                text: error.message,
              });
            }
          }
        );
    }
  }

  async updateAction(config: any, action: any) {
    this.model = {
      ...action,
    };
    await this.$http.ressifnet.actionsPreventionSanteTravail
      .put(this.$route.params.idEntreprise, this.projetId, action.id, this.model, config)
      .then(
        (response: string) => {
          this.percentUpload = 0;

          successAlert.fire({
            title: "Mise à jour d'une action",
            text: "Mise à jour effectuée avec succès",
          });

          this.$emit("element-added");
          this.resetModel();
          (this.$refs["formValidation"] as any).reset();
          this.selectAction(action.id, 'view')
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
          this.percentUpload = 0;
        }
      );
  }

  removeFichier(fichier: any) {
    if (fichier.id != undefined) {
      this.$bvModal
        .msgBoxConfirm(
          "Etes-vous sûr de vouloir supprimer ce fichier de l'action ? Cela le supprimera directement",
          {
            title: "Confirmation de suppression",
            size: "sm",
            okVariant: "primary",
            okTitle: "Oui",
            cancelTitle: "Non",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (value === true) {
            this.confirmRemoveFichier(fichier);
          } else {
            return;
          }
        });
    } else {
      this.model.fichiers = this.model
        .fichiers!.filter((f: any) => f.name != fichier.nom );
    }
  }

  async confirmRemoveFichier(fichier: any) {
    await this.$http.ressifnet.actionsPreventionSanteTravail
      .deleteFile(
        this.$route.params.idEntreprise,
        this.projetId,
        (this.model as any).id,
        fichier.id
      )
      .then((res: any) => {
        successAlert.fire({
          title: "Suppression d'un document",
          text: "Suppression effectuée avec succès",
        });

        (this.model.fichiers! as any[]).push({ id: fichier.id });
        this.fichiersUploaded = this.fichiersUploaded
          .filter((f: any) => f.nom != fichier.nom );
      });
  }

  
  async loadTypesActions() {
    await this.$http.ressifnet.typesActionPreventionSanteTravail
      .paginatedList(1, 50, true)
      .then((res: PaginatedList<TypeActionPreventionSanteTravail>) => {
        this.listTypes = res;
      });
  }

  get fichiers() {
    var files = [];

    if (this.model.fichiers && this.model.fichiers.length > 0) {
      files = this.model
        .fichiers.filter((f: any) => f.id == undefined)
        .map(
          (x: File) =>
            <any>{
              nom: x.name,
            }
        );
    }
    return files.concat(this.fichiersUploaded);
  }
}
